module.exports = __webpack_public_path__ + "img/Bunga@2x.d309977b.png";